import styled from 'styled-components/macro';

import { Box } from '@olist/united';

export const Wrapper = styled(Box).attrs({
  mx: '-5px',
  mt: [-6, 'unset'],
  mb: 6,
  pt: [6, '20px'],
  px: '5px',
  pb: 2,
})`
  overflow: hidden;
`;

export const CustomSelect = styled.div`
  position: relative;

  svg {
    position: absolute;
    right: 16px;
    top: 30%;
  }
  select {
    -webkit-appearance: none;
    align-items: center;
    background-color: transparent;
    border: none;
    border-radius: 8px;
    box-shadow: none;
    box-sizing: border-box;
    color: #312f4f;
    display: flex;
    font-size: 16px;
    font-weight: 800;
    height: 100%;
    line-height: 24px;
    margin-top: 8px;
    outline: 1px solid #d1d1e3;
    padding: 16px 52px 16px 16px;
    width: 100%;

    .empty-option {
      font-weight: 800;
    }

    &:focus {
      outline: 2px solid #0c29d0;
    }
  }
`;
